// client/src/components/LogoWordmark.jsx
// Compact TicTac mark for the back-office header: wordmark + slogan only,
// no icon. Stacked layout fits in a ~36px-tall row without dominating.
//
// Same Fredoka + Rubik fonts as the full logo (loaded by client/index.html),
// same gradient palette, same Hebrew slogan. Drop in anywhere with a
// className for sizing — viewBox handles proportional scaling.

export default function LogoWordmark({ className = '' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 180 50"
      className={className}
      role="img"
      aria-label="TicTac · המעשה. הנקודה. הזכות."
    >
      <defs>
        <linearGradient id="logoMarkTicGrad" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#fb7185" />
          <stop offset="100%" stopColor="#fbbf24" />
        </linearGradient>
        <linearGradient id="logoMarkTacGrad" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#4f46e5" />
          <stop offset="100%" stopColor="#22d3ee" />
        </linearGradient>
      </defs>

      {/* Wordmark */}
      <g transform="translate(90, 30)" textAnchor="middle">
        <text
          fontSize="32"
          fontFamily='"Fredoka", "Varela Round", "SF Pro Rounded", ui-rounded, system-ui, sans-serif'
          fontWeight="700"
          letterSpacing="-0.04em"
        >
          <tspan fill="url(#logoMarkTicGrad)">Tic</tspan>
          <tspan fill="url(#logoMarkTacGrad)">Tac</tspan>
        </text>
      </g>

      {/* Tagline */}
      <g transform="translate(90, 44)" textAnchor="middle">
        <text
          fontSize="9"
          fill="#312e81"
          direction="rtl"
          fontFamily='"Rubik", "Heebo", system-ui, sans-serif'
          fontWeight="500"
        >
          המעשה<tspan fill="#f59e0b" fontWeight="700">.</tspan>
          {' '}הנקודה<tspan fill="#f59e0b" fontWeight="700">.</tspan>
          {' '}הזכות<tspan fill="#f59e0b" fontWeight="700">.</tspan>
        </text>
      </g>
    </svg>
  );
}
